import script from "./HszdCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HszdCard.vue?vue&type=script&setup=true&lang=js"

import "./HszdCard.vue?vue&type=style&index=0&id=88761686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88761686"]])

export default __exports__